import { createAsyncThunk } from '@reduxjs/toolkit';
import { cliente } from '@config/axios';
import { apiEndpoints } from '@config/apiEndpoints';

export const GetAvisos = createAsyncThunk('avisos/getavisos', async () => cliente.get(apiEndpoints.AVISOS.GET_AVISOS));

export const ReadAviso = createAsyncThunk('avisos/readaviso', async (id: string | number) =>
  cliente.get(apiEndpoints.AVISOS.READ_AVISO, { params: { id: id } })
);
